import { CONTENT_TYPES } from "@/react/story/data";
import type { Content, ContentInfos, Locale } from "@/react/story/types";

export default function contentToInfos(content: Content, locale: Locale): ContentInfos | null {
    const config = CONTENT_TYPES.find(c => c.value === content.type);
    if (!config) {
        return null;
    }

    return {
        label: config.label,
        placeholder: config.placeholder,
        icon: config.icon,
        field: config.field,
        text: config.toText(content, locale),
    };
}
